import { getRuleValue, type RuleOverrides } from "../../data/ruleRegistry";

export function lookupHeaderDepth(
	widthMm: number,
	overrides: RuleOverrides = {},
) {
	const table = getRuleValue<Record<string, number>>(
		"framing.headerSpanTable",
		overrides,
	);
	const spans = Object.keys(table)
		.map(Number)
		.sort((a, b) => a - b);
	const match = spans.find((span) => span >= widthMm);
	return {
		depthMm: table[String(match ?? spans[spans.length - 1])],
		exceedsSpanTable: match === undefined,
	};
}
